<sticky-free [stickyId]="'listing-filters'"
             [style.z-index]="10"
             class="pos-relative _sticky"
             [order]="10">
    <div class="p-t-5 p-t-4-s p-t-4-m bg-col-w p-l-6 p-r-6 p-l-4-s p-r-4-s"
         [ngClass]="{'p-b-5 p-b-4-s p-b-4-m': filtersWithSelection && filtersWithSelection.length > 0}"
         *ngIf="true">
        <ng-container [ngSwitch]="type">
            <ng-container *ifSize="'SM'">
                <ng-container *ngTemplateOutlet="noResultInfo"></ng-container>
            </ng-container>
            <div class="flex flex-middle">
                <!-- listing size -->
                <div class="flex"
                     [style.font-size.em]="app.client.isS ? 1.42 : 1.6">
                    <div class="inline-block va-m">
                        @if(sizeOutlet) {
                        <ng-container *ngComponentOutlet="sizeOutlet.component; inputs: $any(sizeOutlet).inputs" />
                        }
                    </div>
                </div>

                <!-- vbar -->
                <div class="vbar m-l m-r"></div>

                <!-- products -->
                <span class="p2 col-11 no-wrap">
                    {{ (getTotal === 1 ? '% Product' : '% Products') | translate : getTotal }}
                </span>

                <!-- hfill -->
                <div class="flex-grow"></div>

                <!-- count of results -->
                <div class="w-12 flex flex-justify-between flex-middle"
                     *ngSwitchCase="'bulkOrder'">
                    <div *ifSize="'!S'"
                         class="m-r-10 p1 col-11 no-wrap flex flex-middle">
                        <ng-container *ifSize="'!M'">
                            <ng-container *ngTemplateOutlet="selectedFilters"></ng-container>
                        </ng-container>
                        {{ (getTotal === 1 ? '% Product' : '% Products') | translate : getTotal }}
                    </div>

                    <ng-container *ifSize="'LX'">
                        <ng-container *ngTemplateOutlet="noResultInfo"></ng-container>
                    </ng-container>

                    <div>
                        <!-- sort options -->
                        @if($any(bulkOrderSortOutlet)?.inputs?.sort) {
                        <ng-container *ngComponentOutlet="
                            bulkOrderSortOutlet.component;
                            inputs: $any(bulkOrderSortOutlet).inputs;
                          " />
                        }
                        @if($any(sizeOutlet)?.inputs?.size) {
                        <ng-container *ngComponentOutlet="
                                    sizeOutlet.component;
                                    inputs: $any(sizeOutlet).inputs;
                                    " />
                        }
                    </div>
                </div>

                <ng-container *ngSwitchDefault>
                    <div>
                        <button class="p2 button w-12 p-l-3 p-r-3 _filters-button"
                                [style.border-radius.px]="24"
                                (click)="showFiltersModal()">{{'Filters & Sort' | translate}}</button>
                    </div>
                </ng-container>
            </div>
        </ng-container>

        <!-- selected filters -->
        <ng-container *ngTemplateOutlet="selectedFilters"></ng-container>
    </div>
</sticky-free>

<!-- Selected filters -->
<ng-template #selectedFilters>
    <div class="flex flex-wrap m-r-2 p-t-5 p-t-4-s p-t-4-m"
         [style.gap.px]="8">
        @for (filter of filtersWithSelection; track $index) {
        @if(['ac-filter', 'ac-filter-range', 'attribute-option', 'attribute-range'].includes(filter.filterType) ||
        (['stock', 'attribute-option'].includes($any(filter).config?.type))) {
        @switch($any(filter).filterType) {
        @default {
        @for(optionId of $any(filter).selection; track $index) {
        <button class="no-wrap flex flex-middle bg-col-51 p-t-1 p-b-1 p-l-2 p-r-2">
            <span class="inline-block c1 no-wrap">
                {{$any(filter).getOptionLabel(optionId)}}
            </span>
            <i class="inline-flex icon-close m-l-2"
               [style.font-size.px]="7"
               (click)="$any(filter).unselect(optionId)"></i>
        </button>
        }
        }
        @case ('attribute-range') {
        <span class="inline-block flex flex-middle c1 bg-col-51 p-t-1 p-b-1 p-l-2 p-r-2">
            @if(asRangeFilter(filter).selection?.min) {
            <price class="inline-block c1 no-wrap"
                   [value]="asRangeFilter(filter).selection!.min"></price>
            }
            <p class="c1">&nbsp;-&nbsp;</p>
            @if(asRangeFilter(filter).selection?.max) {
            <price class="inline-block c1 no-wrap"
                   [value]="asRangeFilter(filter).selection!.max"></price>
            }
        </span>
        <i class="inline-flex icon-close m-l-2"
           [style.font-size.px]="7"
           (click)="asRangeFilter(filter).selection = {}; asRangeFilter(filter).next()"></i>
        }
        @case ('ac-filter') {
        <button class="no-wrap flex flex-middle bg-col-51 p-t-1 p-b-1 p-l-2 p-r-2">
            <span class="inline-block c1 no-wrap">
                {{asAcFilter(filter).value}}
            </span>
            <i class="inline-flex icon-close m-l-2"
               [style.font-size.px]="7"
               (click)="asAcFilter(filter).unselect(asAcFilter(filter).filterProp ,asAcFilter(filter).optionProp)"></i>
        </button>
        }
        @case ('ac-filter-range') {
        <button class="no-wrap flex flex-middle bg-col-51 p-t-1 p-b-1 p-l-2 p-r-2">
            <price class="inline-block c1 no-wrap"
                   [value]="asAcFilterRange(filter).from"></price>
            <p class="c1">&nbsp;-&nbsp;</p>
            <price class="inline-block c1 no-wrap"
                   [value]="asAcFilterRange(filter).to"></price>
            <i class="inline-flex icon-close m-l-2"
               [style.font-size.px]="7"
               (click)="asAcFilterRange(filter).unselect()"></i>
        </button>
        }
        }
        }
        }
        @if(filtersWithSelection && filtersWithSelection.length) {
        <button (click)="clearAllFilters()"
                class="m-l-4 col-11 underline italic">{{'Clear All' | translate}}</button>
        }
    </div>
</ng-template>

<ng-template #noResultInfo>
    <ng-container *ifTradeStore>
        <ng-container *ngIf="noResults">
            <icms-outlet-block name="No result"
                               variant="no-result">
            </icms-outlet-block>
        </ng-container>
    </ng-container>
</ng-template>